exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Cookie--primary{background:#4f4f44;color:#fff;font-size:14px;width:100vw!important;justify-content:center!important;height:100px;text-align:left;padding:0 2rem 0 1rem;flex-direction:row!important}.Cookie--primary .Cookie__content{padding-right:1rem}.Cookie--primary .Cookie__button{background:url(\"/static/assets/images/icons/close_white.svg\");text-indent:-9999px;background-repeat:no-repeat;height:14px;width:14px}.Cookie--primary .Cookie__buttons{margin:0}@media screen and (min-width:48rem){.Cookie--primary{background:#4f4f44;color:#fff;font-size:14px;width:100vw!important;justify-content:center!important;height:50px;text-align:left}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./sv_cms/static/assets/vue/components/svCookieLayer.vue
// module id = 254
// module chunks = 6